import React, { FC }            from "react";
import { useDispatch }          from "react-redux";
import { Card, Form, TextArea } from "semantic-ui-react";
import CustomerRecordRepository from "../../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordWidget     from "../../../../../domain/record/customer/widget/CustomerRecordWidget";
import WidgetValue              from "../../../../../domain/record/widget/WidgetValue";
import CustomerRecordDataSource
                                from "../../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

interface Props {
  widgetIndex: number;
  widget: CustomerRecordWidget;
}

const TextAreaLargeWidget: FC<Props> = (props: Props) => {
  const {widgetIndex, widget} = props;
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  return (
    <>
      <div
        style={ {
          position: "absolute",
          left: `${ widget.coordinate.x }px`,
          top: `${ widget.coordinate.y }px`
        } }
        key={ widgetIndex }
      >
        <Card style={ {width: "460px"} }>
          <Card.Content>
            <Form>
              <Form.Field>
                <label>{ widget.title.value }</label>
                <TextArea
                  style={ {height: "400px", resize: "none"} }
                  fluid
                  defaultValue={ widget.value.value }
                  onChange={ (event, data) => repository.setCustomerRecordWidget(widgetIndex, new CustomerRecordWidget(widget.id, widget.widgetId, widget.type, widget.coordinate, widget.title, new WidgetValue(String(data.value)), widget.items)) }
                />
              </Form.Field>
            </Form>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default TextAreaLargeWidget;
